
<div :class="content.type != null ? 'card-' + content.type : 'card-group'">
  <div v-for="titreSection in cartes" :key="titreSection['id']">
    <CarteObsolete :content="titreSection" :metadata="titreSection"></CarteObsolete>
  </div>
</div>
